import React, {useState} from 'react';
import LogoRender from "../../cmp/LogoRender";
import {useParams} from "react-router-dom";
import useSWR from "swr";
import {get} from "../../../api";
import FormattedNumber from "../../cmp/FormattedNumber";
import CurrencyNumber from "../../cmp/CurrencyNumber";
import CopyButton from "../../cmp/CopyButton";
import SocialShareIcon from "../../cmp/SocialShareIcon";
import QrCodeModal from "../../cmp/qrcodeloader/QRCodeModal";
import {useSelector} from "react-redux";
import LoadingSkeleton from "../../cmp/LoadingSkeleton";
import dayjs from "../../../mydayjs";
import {FormattedDate, FormattedMessage, FormattedTime} from "react-intl";
import {TimezoneDate, TimezoneTime} from "../../cmp/TimezoneTime";
import useToggle from "../../cmp/hooks/useToggle";
import FormattedHelmet from "../../cmp/intl/FormattedHelmet";
import {FiCheck} from 'react-icons/fi';

const current_year = new Date().getFullYear()
function getStatus(data){
    const end = new Date(data?.ends_at).getTime();
    const closed = new Date(data?.closed_at).getTime()
    const starts = new Date(data?.starts_at).getTime();
    const now = Date.now();
    if(starts > now) return 'upcoming';
    if(!data?.closed_at && end > now) return 'active';
    else if(data?.closed_at && closed  < end) return 'ended';
    else return "completed";
}
function PublicPartyDetailsPage(props) {
    const id = useParams().id
    const parts = String(id).split('-')
    const sub_id = parts.pop();
    const ref_code = parts.join('-')
    const {data, isLoading} = useSWR(
        ref_code && sub_id ?
            //@ts-ignore
        `/public-showcases?ref_code=${ref_code}&sub_id=${sub_id}` : null, get)
    //@ts-ignore
    const website = useSelector((state)=>state.settings?.website)
    const link =
        data?.hostUrl ||
        `https://${website}/?ref_code=${ref_code}&sub_id=${sub_id}`
    const status = data ? getStatus(data) : 'active'
    const item = data || {}
    return (
        <div className="bg-light min-vh-100">
        <div className={"pt-4 mx-2"}>
            {
                data?
                <FormattedHelmet id={data?.partyTitle || data?.hostName} /> : null
            }
            <div className="text-center mb-3">
                <LogoRender/>
            </div>
            <div className="d-flex justify-content-center">
                <div style={{maxWidth: 600, width: '100%'}}>
                    {
                        isLoading ? <LoadingSkeleton height={24} count={12} /> :
                            <div className="card shadow-sm overflow-hidden">
                                {status === "completed" ?
                                <div className="bg-success text-white text-center"
                                    style={{fontSize:14}}
                                >{status.toUpperCase()}</div> : null
                                }
                                {status === "upcoming" ?
                                    <div className="bg-warning text-white text-center"
                                         style={{fontSize:14}}
                                    >{status.toUpperCase()}</div> : null
                                }

                        <div className="card-body">
                            <div className="text-center">
                                <span>{data?.affiliate?.name}<br/>{data?.affiliate?.email}</span>
                            </div>
                            <div className="text-center">
                                <div className="fs-2">X</div>
                            </div>
                            <div className="text-center">
                                <span>{data?.hostName}<br/>{data?.hostEmail}</span>
                            </div>
                            {
                                status === "active" || status === "upcoming" ?
                                    <div className="text-center mt-2 mb-2 d-flex align-items-center justify-content-center">
                                        <CopyButton text={link}
                                                    className={"btn mr-2 btn-sm btn-outline-primary"}
                                                    title={"Copy Link"} />
                                        <QRButton link={link}/>
                                    </div> : null
                            }
                        </div>
                        <ul className="list-group list-group-flush">
                            <ShowcaseListItem title={"Start date"}>
                                <time
                                    title={dayjs(data?.starts_at).format('YYYY-MM-DD HH:mm a')}
                                    dateTime={dayjs(data?.starts_at).format('YYYY-MM-DD HH:mm')}>
                                    <small className={'text-muted mr-2'}>
                                        <FormattedTime
                                            value={new Date(data?.starts_at)}
                                            minute={'numeric'} hour12 hour={'numeric'}
                                        />
                                    </small><FormattedDate
                                    year={current_year !== new Date(data?.starts_at).getFullYear() ? 'numeric' : undefined}
                                    value={new Date(data?.starts_at)} day={"numeric"} month={"long"} /></time>
                            </ShowcaseListItem>
                            {
                                status === "ended" ? <ShowcaseListItem title={"End date"}>
                                        <time>
                                            <small className={'text-muted mr-2'}>
                                                <FormattedTime
                                                    value={new Date(data?.closed_at)}
                                                    minute={'numeric'} hour12 hour={'numeric'}/>
                                            </small>
                                            <FormattedDate
                                                year={current_year !== new Date(data?.closed_at).getFullYear() ? 'numeric' : undefined}
                                                value={new Date(data?.closed_at)} day={"numeric"} month={"long"} />
                                        </time>
                                    </ShowcaseListItem> :
                                    <ShowcaseListItem title={"End date"}>
              <span>
                <small className={'text-muted mr-2'}>
            <TimezoneTime
                value={new Date(data?.ends_at)}
                minute={'numeric'} hour12 hour={'numeric'}/>
          </small>
                <TimezoneDate
                    value={new Date(data?.ends_at)}
                    year={current_year !== new Date(data?.ends_at).getFullYear() ? 'numeric' : undefined}
                    day={"numeric"} month={"long"} /></span>
                                    </ShowcaseListItem>
                            }
                            <TotalSales num_orders={data?.orders.num_orders}
                                        isLoading={isLoading}
                                        sales={data?.orders?.sales}/>
                            <ShowcaseListItem title={"Total Volume"}>
                                <span>
                                    {isLoading ? '-' : <CurrencyNumber value={data?.orders?.subtotal} />}
                                </span>
                            </ShowcaseListItem>
                            {
                                item.rewardAmount > 0 || item.additionalRewards?.length > 0 ?
                                    <div className="px-1 py-1 party-host-reward-section">
                                        <div className="px-2 pt-1">
                                            <h6>Host's reward</h6>
                                        </div>
                                        <ul className="list-group">
                                            {
                                                item.rewardAmount > 0 ? <>
                                                    <ShowcaseListItem title={generateLabel({discount_value: item.rewardAmount, discount_type: item.rewardType})}>
                                                        <span>{item.rewardCode || <FiCheck className={"text-success"} />}</span>
                                                    </ShowcaseListItem> </> : null
                                            }
                                            {
                                                item.additionalRewards ? item.additionalRewards.map(({label, discountConfig, code})=>{
                                                    return  <ShowcaseListItem key={label || code} title={label || generateLabel(discountConfig)}>
                                                        <span>{code || <FiCheck className={"text-success"} />}</span>
                                                    </ShowcaseListItem>
                                                }) : null
                                            }
                                        </ul>
                                    </div> : null
                            }
                        </ul>
                    </div>
                    }
                </div>
            </div>
        </div>

        </div>

    );
}

function TotalSales({num_orders, isLoading, sales}){
    const [visible, toggleVisibility] = useToggle()
    return <>
        <ShowcaseListItem title={"Total Sales"} onClick={toggleVisibility}>
            {isLoading ? '-' :
                <span><FormattedNumber value={num_orders}/></span>
            }
        </ShowcaseListItem>
        {
            visible  ? <>
                {
                    <ul className={"list-group mt-1 ml-1 mr-1"}>{
                        sales?.map(({number, customer,subtotal}) => {
                            return <li
                                       className={"list-group-item list-group-item-action"}
                                       key={String(number)}>
                                <div
                                    className={'d-flex align-items-center justify-content-between'}>
                                    <div className="mark px-2">
                                        {number}
                                    </div>
                                    <span><CurrencyNumber value={subtotal}/></span>
                                </div>
                                <div>
                                    {customer?.name}
                                </div>
                                <small className={"text-muted"}>{customer?.email}</small>
                            </li>
                        })
                    }</ul>
                }
            </> : null
        }
    </>
}

function ShowcaseListItem({title, children, onClick}){
    return <li className={`list-group-item d-flex align-items-center justify-content-between ${onClick ? 'list-group-item-action text-primary' : ''}`} style={{cursor:onClick ? 'pointer': 'auto'}} onClick={onClick}>
        <span>{typeof title === "string" ? <FormattedMessage id={title} /> : title}</span>
        <span>{children}</span>
    </li>
}

function QRButton({link}){
    const [showQrModal, toggleQRModal] = useState(false)
    return <>
        <SocialShareIcon disabled={!link} onClick={()=>toggleQRModal(true)} alt={"QR Code"}
                         src={"/images/qr-code.svg"}/>
        <QrCodeModal value={link} onClose={()=>toggleQRModal(false)} visible={showQrModal}/>
    </>
}

function generateLabel(data){

    const {
        discount_value, discount_type
    } = data || {}
    switch (discount_type){
        case "percentage":
            return `${discount_value}% off coupon`
        default:
            return <><CurrencyNumber value={discount_value || 0} /> off coupon</>
    }
}
export default PublicPartyDetailsPage;
